import React from 'react';

let lastSidebarType = null;

export default class SidebarMenuItem extends React.Component {

    onClick() {
        const ui = APP.uiHandler.ui;
        ui.showSidebar(this.props.name);
    }

    render() {
        const ui = APP.uiHandler.ui;
        const active = ui.state.sidebar.type==this.props.name;
        const classes = this.props.className;
        if (active && lastSidebarType != ui.state.sidebar.type) {
            lastSidebarType = ui.state.sidebar.type;
            APP.model.showDoorsClosed(this.props.doorsClosed);
        }
        return (
            <div className={`${active?"active-menu-item":""} image-text stop-select ${classes}`} onClick={() => this.onClick()}>
                <div className="image no-pointer">
                    <img className="footer-img" src={this.props.image} />
                </div>
                {this.props.label}
            </div>
            
        );
    }
}